import React from 'react';
import ProfileImage from './ProfileImage';

function ProfileImages({ icons }) { // Destructure icons from props
  return (
    <>
      <section className="profile-images">
        {icons.map((image, index) => (
          <a key={index} href={image?.link?.href} target="_blank" rel="noopener noreferrer">
            <ProfileImage src={image?.logo?.url} alt={image?.link?.title} />
          </a>
        ))}
      </section>
      <style jsx="true">{`
        .profile-images {
          align-self: stretch;
          display: flex;
          margin-top: 10px;
          gap: 10px;
          flex-wrap: wrap; /* Allows items to wrap in case of overflow */
        }
        a {
          display: inline-block;
        }
        @media (max-width: 991px) {
          .profile-images {
            justify-content: center; /* Center-align images on mobile */
          }
        }
      `}</style>
    </>
  );
}

export default ProfileImages;